/**
 * 契約情報ページ用のスクリプト
 */
 if (is_route('license_setting.index')) {
    // コンテンツ読み込み後
    $(document).on('amc:onload', function() {
        license_seetting_event_set();
    });
}
/**
 * ページ読み込み時のイベント設定
 */
 window.license_seetting_event_set = function() {

    /*---- 削除確認時 ----*/

    // 削除確認時
    $(document).on('click', '[data-confirm-modal]', function () {
        _modal.create(this, 'confirm-modal', ['id']);
    });

    /*---- 削除時 ----*/

    // 削除実行時
    $(document).on('click', '[data-delete-modal]', function () {
        _modal.submit(this, 'delete-modal');
    });

}
